export default function( defaults ){

	defaults.arrows = {
		position: 'beforebegin',
		template: `<div class="finalCarouselControlsArrows"><button class="finalCarouselControlArrowLeft">←</button><button class="finalCarouselControlArrowRight">→</button></div>`,
	}


	defaults.on.init_complete = function(){

		let arrows = document.createElement('template');
		arrows.innerHTML = this.params.arrows.template;

		let node = arrows.content.cloneNode(true).children[0];

		[...node.children].map((arrow) => arrow.addEventListener('click', (e) => {
			if( arrow.previousElementSibling )
				this.swapBy( 1 )
			else
				this.swapBy( -1 )
		}) )

		this.root.insertAdjacentElement( this.params.arrows.position, node );

		this.arrows = [ ... node.children ];

		arrowsAccesibilityCheck.apply( this, [this.current] );

	}

	defaults.on.swap_start = function( current, target ){
		arrowsAccesibilityCheck.apply( this, [target] );
	}

	defaults.on.swap_end = function(){
		arrowsAccesibilityCheck.apply( this, [this.current] );
	}

	function arrowsAccesibilityCheck( element ){

		if( this.params.align == 'start' ){

			this.arrows[0].disabled = !element.previousElementSibling

			this.arrows[1].disabled = (
				!element.nextElementSibling
				||
				!this.params.effect.availableFor(element.nextElementSibling)
			)

		}

	}

}